/* Maps a directory facility LABEL (the values the AI parse-search + filter chips emit) to the
   masjid `attributes` jsonb KEY that records it. SHARED by the client directory filter
   (includesFacility) and the /api/masjids server filter, so a facility matches identically on
   both: it counts when the label appears in the free-text `facilities[]` array OR when
   `attributes[key] === true`. Keep this the single source so client and server can't drift.

   Note: 'Live Events' has no populated attribute key yet (no facilityCollection backs it), so it
   currently matches only via the facilities[] text array — mapped here for completeness so a
   future `live_events` attribute works without another code change. */
export const FACILITY_ATTR: Record<string, string> = {
  'Women Section': 'womens_section',
  'Wheelchair Accessible': 'wheelchair_accessible',
  'Quran Classes': 'quran_classes',
  'Parking': 'parking',
  'Wudu Area': 'wudu',
  'Live Events': 'live_events',
}
